<template>
  <div class="baseball-list list-team">
    <h6 class="a11y-hidden">전체, 팀 선택</h6>
    <ul>
      <!-- li 선택 되었을 때 class.on 필요-->
      <li :class="`baseball-list-team team-all ${teamCode === 'all' ? 'on' : ''}`" data-code="all">
        <a href="#" @click.prevent="selectTeam('all')">
          <span>전체</span>
        </a>
      </li>
      <li :class="`baseball-list-team team-each ${teamCode === team.code ? 'on' : ''}`"
          v-for="(team, index) in kboTeamList" :data-code="team.code" :key="'team_'+ index">
        <a href="#" @click.prevent="selectTeam(team.code)">
          <span><img :src="team.image"></span>
          <span>{{team.name}}</span>
        </a>
      </li>
    </ul>
  </div>
</template>
<script>
  import { KBO_TEAM_LIST } from '@/common/resources/const'
export default {
  componentName: 'KboTeamList',
  props: {
    changeFn: {
      type: Function
    },
    teamCode: {
      type: String
    }
  },
  data () {
    return {
      kboTeamList: KBO_TEAM_LIST
    }
  },
  methods: {
    selectTeam (teamCode) {
      this.changeFn(teamCode)
    }
  }
}
</script>
